module.exports = __webpack_public_path__ + "img/38.ea4408e1.svg";